import { useAsync } from 'react-use'
import { useTranslation } from 'react-i18next'
import { Event } from '@nostr/tools/wasm'
import client from '@/services/client.service'
import { cn } from '@/lib/utils'
import { tagNameEquals } from '@/lib/tag'
import Emoji from '../Emoji'
import { parseReactionEmoji } from '../ReactionList'
import ContentPreview from '../ContentPreview'

export default function ReactionPreview({
  event,
  className
}: {
  event: Event
  className?: string
}) {
  const { t } = useTranslation()
  const { value: targetEvent } = useAsync(async () => {
    const eTag = event.tags.find(tagNameEquals('e'))
    if (eTag?.[1]) {
      return client.fetchEvent({
        id: eTag[1],
        relays: eTag[2] ? [eTag[2]] : [],
        author: eTag[4]
      })
    }

    const aTag = event.tags.find(tagNameEquals('a'))
    if (aTag?.[1]) {
      const [kind, pubkey, ...identifier] = aTag[1].split(':')
      return client.fetchEvent({
        kind: Number(kind),
        pubkey,
        identifier: identifier.join(':'),
        relays: aTag[2] ? [aTag[2]] : []
      })
    }

    return undefined
  }, [event])

  return (
    <div className={cn('flex items-center gap-1.5 text-sm text-muted-foreground', className)}>
      <Emoji
        emoji={parseReactionEmoji(event)}
        classNames={{ text: 'text-base', img: 'size-3.5' }}
      />
      <span className="shrink-0">{t('reacted')}</span>
      {targetEvent && <ContentPreview className="truncate ml-1" event={targetEvent} />}
    </div>
  )
}
